abstract class Role {

  public getRoleId(): number {
    return Object.getPrototypeOf(this).constructor.contactRoleId;
  }
}

export { Role }
